import {message} from "antd";

let websocket, lockReconnect = false;
let createWebSocket = (url, callback,callback2) => {
  console.log(url)
  console.log('添加活动websocket 建立连接...')
  websocket = new WebSocket(url);
  websocket.onopen = function () {
    console.log('添加活动websocket onopen')
    heartCheck.reset().start();
  }
  websocket.onerror = function () {
    console.log('添加活动websocket onerror')
    lockReconnect = false;
    reconnect(url);
  };
  websocket.onclose = function (e) {
    console.log('添加活动websocket 断开: ' + e.code + ',' + e.reason + ',' + e.wasClean)
    lockReconnect = false;
    if (e.code === 1000) {
      console.log('添加活动websocket 主动断开')
    } else {
      reconnect(url);
    }
  }
  websocket.onmessage = function (event) {
    // console.log(event)
    // console.log(event.data)
    if (event.data === 'HeartBeat') {
      // console.log('添加活动websocket 心跳包')
    } else {
      let data = JSON.parse(event.data)
      lockReconnect = true;
      //event 为服务端传输的消息，在这里可以处理
      if (data.dataHandleStatus === 1) {
        callback(false)
        message.success('添加成功')
        callback2(2)
      }

    }
  }
}
let reconnect = (url) => {
  if (lockReconnect) return;
  //没连接上会一直重连，设置延迟避免请求过多
  setTimeout(function () {
    createWebSocket(url);
    lockReconnect = false;
  }, 20000);
}
let heartCheck = {
  timeout: 60000, //60秒
  timeoutObj: null,
  reset: function () {
    clearInterval(this.timeoutObj);
    return this;
  },
  start: function () {
    this.timeoutObj = setInterval(function () {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      websocket.send("HeartBeat");
    }, this.timeout)
  }
}
//关闭连接
let closeWebSocket = () => {
  console.log('添加活动websocket closeWebSocket')
  websocket && websocket.close();
}


export {
  websocket,
  createWebSocket,
  closeWebSocket,
  reconnect
};



// WEBPACK FOOTER //
// ./src/utils/websocketUtil.js